export var EMeetingSlotStatus;
(function (EMeetingSlotStatus) {
    EMeetingSlotStatus["CONFIRMED"] = "confirmed";
    EMeetingSlotStatus["REJECTED"] = "rejected";
    EMeetingSlotStatus["PENDING"] = "pending";
})(EMeetingSlotStatus || (EMeetingSlotStatus = {}));
